import React from 'react';
import { KenoBetDetails } from './KenoBetDetails';
import { BlackjackBetDetails } from '../blackjack/BlackjackBetDetails';
import { OriginalBetDetails } from '../originals/OriginalBetDetails';

export const GameBetDetails = (props) => props.round.game === 'blackjack' ? <BlackjackBetDetails {...props} /> : ['mines', 'limbo', 'dice', 'plinko'].includes(props.round.game) ? <OriginalBetDetails {...props} /> : <KenoBetDetails {...props} />;